import { useMemo, useState } from "react";
import { useTable } from "react-table";
import {
  extractReadableDateOnly,
  formatCurrency,
  nFormatter,
} from "../../../../helpers";
import primaryComponents from "../../../primaryComponents";
import { DeleteIcon } from "../../../../assets/svgIcons";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { ProgressBar } from "../../../common";
import { pathConstants } from "../../../../routes/pathContants";
import { Link, useNavigate } from "react-router-dom";
import secondaryComponents from "../..";
import { statusColor } from "../../../../localdata/goalsStatus";

export const useGoalsTable = ({ goalsList = [] }) => {
  const [isDeleteGoal, setIsDeleteGoal] = useState(null);

  const navigate = useNavigate();
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        Cell: ({ row, cell: { value } }) => (
          <Link
            to={pathConstants.PERFORMANCE_GOALS_DETAILS({
              id: row?.original?.id,
            })}
            className="purple--text cursor-pointe"
          >
            {value}
          </Link>
        ),
      },
      {
        Header: "Store",
        accessor: "stores",
        Cell: ({ row, cell: { value } }) => (
          <span className="d-flex align-items-center">
            {value
              ?.filter((store, index) => {
                if (index > 1) return false;

                return true;
              })
              .map((store) => store?.name)
              ?.join(", ")}

            {value.length > 2 ? (
              <>
                ...
                <span
                  className={`ml-3 ${globalStyles["statusBlock"]} px-1 py-1`}
                  style={{
                    minWidth: "auto",
                    fontSize: "10px",
                    textWrap: "nowrap",
                  }}
                >
                  {value.length - 2} More
                </span>
              </>
            ) : null}
          </span>
        ),
      },
      {
        Header: "Period",
        accessor: "start_date",
        Cell: ({ row, cell: { value } }) => (
          <span className="d-flex" style={{ gap: "15px" }}>
            <span>
              <span
                className="d-block smallest-text-size gray--text mb-1"
                style={{ fontStyle: "italic" }}
              >
                From
              </span>

              <span className="dark--text">
                {extractReadableDateOnly(value)}
              </span>
            </span>
            <span>
              <span
                className="d-block smallest-text-size gray--text mb-1"
                style={{ fontStyle: "italic" }}
              >
                to
              </span>

              <span className=" dark--text">
                {extractReadableDateOnly(row?.original?.end_date)}
              </span>
            </span>
          </span>
        ),
      },
      {
        Header: "Progress",
        accessor: "revenue_amount",
        Cell: ({ row, cell: { value } }) => (
          <span className="w-100">
            <span>
              {formatCurrency({
                value: value,
                currencyCode: row?.original?.store?.currency_code,
              })}
            </span>
            <br />
            <span className="d-flex align-items-center">
              <span style={{ width: "120px" }}>
                <ProgressBar
                  progress={row?.original?.revenue_percentage}
                  width="120px"
                />
              </span>
              <span
                className="ml-1"
                style={{ fontSize: "10px", fontStyle: "italic" }}
              >
                {row?.original?.revenue_percentage != null
                  ? `${nFormatter(row.original.revenue_percentage.toFixed(2), 2)}%`
                  : "N/A"}
              </span>
            </span>
          </span>
        ),
      },
      {
        Header: "Target",
        accessor: "target_amount",
        Cell: ({ cell: { value }, row }) =>
          formatCurrency({
            value: value,
            currencyCode: row?.original?.store?.currency_code,
          }),
      },
      {
        Header: "Outcome",
        accessor: "outcome",
        Cell: ({ cell: { value } }) => (
          <span
            className={`${globalStyles.statusBlock} ${globalStyles[statusColor[value]]}`}
          >
            {value?.replace("_", " ")}
          </span>
        ),
      },

      {
        Header: "Actions",
        Cell: ({ row }) => (
          <span className="d-flex align-items-center" style={{ gap: "10px" }}>
            <primaryComponents.Button
              className="btn btn--primary smallBtn"
              onClick={() => {
                navigate(
                  pathConstants?.PERFORMANCE_GOALS_DETAILS({
                    id: row?.original?.id,
                  }),
                );
              }}
            >
              View
            </primaryComponents.Button>

            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey={"can_delete_revenue_goal"}
            >
              <span
                className="cursor-pointer"
                onClick={() => setIsDeleteGoal(row?.original)}
              >
                <DeleteIcon />
              </span>
            </secondaryComponents.NavigateWithPermission>
          </span>
        ),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: goalsList || [] });

  return {
    instance,
    isDeleteGoal,
    setIsDeleteGoal,
  };
};
